import { default as exercise_45trackerBzltJSf1m7Meta } from "/app/pages/activity/exercise-tracker.vue?macro=true";
import { default as meditation_45trackergYqUwsu27rMeta } from "/app/pages/activity/meditation-tracker.vue?macro=true";
import { default as activity3D5wENJINLMeta } from "/app/pages/activity.vue?macro=true";
import { default as indexi8nCATZISJMeta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginjuBiVElJesMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as indexVqigc7uGylMeta } from "/app/pages/admin/shop-orders/index.vue?macro=true";
import { default as _91page_93S5lJToEM5bMeta } from "/app/pages/admin/shop-orders/page/[page].vue?macro=true";
import { default as indexkE2nokGAlHMeta } from "/app/pages/admin/test-requests/index.vue?macro=true";
import { default as _91page_93Y7NVqzrQ4WMeta } from "/app/pages/admin/test-requests/page/[page].vue?macro=true";
import { default as indexYm9dzWmM2AMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as _91page_93TxTzDWQjxgMeta } from "/app/pages/admin/users/page/[page].vue?macro=true";
import { default as confirmj8tMvini4qMeta } from "/app/pages/auth/confirm.vue?macro=true";
import { default as loginikXFF2hTKwMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as registerTCvAsPw3TEMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as diet_45trackerHuONu4xFd9Meta } from "/app/pages/diet-tracker.vue?macro=true";
import { default as dietQjawD62golMeta } from "/app/pages/diet.vue?macro=true";
import { default as exercise_45doI3iSyudIGkMeta } from "/app/pages/exercise-do.vue?macro=true";
import { default as exercisem9SATYLrJIMeta } from "/app/pages/exercise.vue?macro=true";
import { default as _91expertId_93i22XIvoddvMeta } from "/app/pages/experts/[expertId].vue?macro=true";
import { default as edit_45profile9X3heypSReMeta } from "/app/pages/experts/edit-profile.vue?macro=true";
import { default as indexnpdT0JfAhGMeta } from "/app/pages/experts/index.vue?macro=true";
import { default as search3IVBizauxsMeta } from "/app/pages/experts/search.vue?macro=true";
import { default as homeH3NsyxtJwrMeta } from "/app/pages/home.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as insighttuGVwswgtYMeta } from "/app/pages/insight.vue?macro=true";
import { default as integration5OIuve0YMhMeta } from "/app/pages/integration.vue?macro=true";
import { default as add0M9PZgNwJNMeta } from "/app/pages/manage-blood-tests/add.vue?macro=true";
import { default as index9Elpj8EnZ6Meta } from "/app/pages/manage-blood-tests/index.vue?macro=true";
import { default as addx2O3s2izsWMeta } from "/app/pages/manage-events/add.vue?macro=true";
import { default as addhpe3NeWxLAMeta } from "/app/pages/manage-medicines/add.vue?macro=true";
import { default as indexk5tQnOwITiMeta } from "/app/pages/manage-medicines/index.vue?macro=true";
import { default as manage_45testsVt5Hq0CvpJMeta } from "/app/pages/manage-tests.vue?macro=true";
import { default as meditationELSFM90O91Meta } from "/app/pages/meditation.vue?macro=true";
import { default as notifications883AI3QFtaMeta } from "/app/pages/notifications.vue?macro=true";
import { default as onboardingY3u2kqL19PMeta } from "/app/pages/onboarding.vue?macro=true";
import { default as _91_46_46_46slug_93QJRK5g1YZ6Meta } from "/app/pages/page/[...slug].vue?macro=true";
import { default as pose_45testnxVflwwJb7Meta } from "/app/pages/pose-test.vue?macro=true";
import { default as profileupBlgdy3vLMeta } from "/app/pages/profile.vue?macro=true";
import { default as request_45new_45testKhQrJPfFTtMeta } from "/app/pages/request-new-test.vue?macro=true";
import { default as cartRH4WHc4AXrMeta } from "/app/pages/shop/cart.vue?macro=true";
import { default as indexNvxd1fRHrwMeta } from "/app/pages/shop/index.vue?macro=true";
import { default as order_45confirmationlHkZIHLQx1Meta } from "/app/pages/shop/order-confirmation.vue?macro=true";
import { default as order_45doneBCftytavRwMeta } from "/app/pages/shop/order-done.vue?macro=true";
import { default as ordersLQL6ekTo64Meta } from "/app/pages/shop/orders.vue?macro=true";
import { default as paymenttOXdFmr7DPMeta } from "/app/pages/shop/payment.vue?macro=true";
import { default as _91productId_93sZ6lovkuHdMeta } from "/app/pages/shop/product/[productId].vue?macro=true";
import { default as indexUVI39vtgp1Meta } from "/app/pages/test/index.vue?macro=true";
import { default as vivaiHwv6rVa4baMeta } from "/app/pages/vivai.vue?macro=true";
import { default as workoutTVjCE2fZquMeta } from "/app/pages/workout.vue?macro=true";
export default [
  {
    name: activity3D5wENJINLMeta?.name ?? "activity",
    path: activity3D5wENJINLMeta?.path ?? "/activity",
    meta: activity3D5wENJINLMeta || {},
    alias: activity3D5wENJINLMeta?.alias || [],
    redirect: activity3D5wENJINLMeta?.redirect,
    component: () => import("/app/pages/activity.vue").then(m => m.default || m),
    children: [
  {
    name: exercise_45trackerBzltJSf1m7Meta?.name ?? "activity-exercise-tracker",
    path: exercise_45trackerBzltJSf1m7Meta?.path ?? "exercise-tracker",
    meta: exercise_45trackerBzltJSf1m7Meta || {},
    alias: exercise_45trackerBzltJSf1m7Meta?.alias || [],
    redirect: exercise_45trackerBzltJSf1m7Meta?.redirect,
    component: () => import("/app/pages/activity/exercise-tracker.vue").then(m => m.default || m)
  },
  {
    name: meditation_45trackergYqUwsu27rMeta?.name ?? "activity-meditation-tracker",
    path: meditation_45trackergYqUwsu27rMeta?.path ?? "meditation-tracker",
    meta: meditation_45trackergYqUwsu27rMeta || {},
    alias: meditation_45trackergYqUwsu27rMeta?.alias || [],
    redirect: meditation_45trackergYqUwsu27rMeta?.redirect,
    component: () => import("/app/pages/activity/meditation-tracker.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexi8nCATZISJMeta?.name ?? "admin",
    path: indexi8nCATZISJMeta?.path ?? "/admin",
    meta: indexi8nCATZISJMeta || {},
    alias: indexi8nCATZISJMeta?.alias || [],
    redirect: indexi8nCATZISJMeta?.redirect,
    component: () => import("/app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: loginjuBiVElJesMeta?.name ?? "admin-login",
    path: loginjuBiVElJesMeta?.path ?? "/admin/login",
    meta: loginjuBiVElJesMeta || {},
    alias: loginjuBiVElJesMeta?.alias || [],
    redirect: loginjuBiVElJesMeta?.redirect,
    component: () => import("/app/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: indexVqigc7uGylMeta?.name ?? "admin-shop-orders",
    path: indexVqigc7uGylMeta?.path ?? "/admin/shop-orders",
    meta: indexVqigc7uGylMeta || {},
    alias: indexVqigc7uGylMeta?.alias || [],
    redirect: indexVqigc7uGylMeta?.redirect,
    component: () => import("/app/pages/admin/shop-orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93S5lJToEM5bMeta?.name ?? "admin-shop-orders-page-page",
    path: _91page_93S5lJToEM5bMeta?.path ?? "/admin/shop-orders/page/:page()",
    meta: _91page_93S5lJToEM5bMeta || {},
    alias: _91page_93S5lJToEM5bMeta?.alias || [],
    redirect: _91page_93S5lJToEM5bMeta?.redirect,
    component: () => import("/app/pages/admin/shop-orders/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexkE2nokGAlHMeta?.name ?? "admin-test-requests",
    path: indexkE2nokGAlHMeta?.path ?? "/admin/test-requests",
    meta: indexkE2nokGAlHMeta || {},
    alias: indexkE2nokGAlHMeta?.alias || [],
    redirect: indexkE2nokGAlHMeta?.redirect,
    component: () => import("/app/pages/admin/test-requests/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93Y7NVqzrQ4WMeta?.name ?? "admin-test-requests-page-page",
    path: _91page_93Y7NVqzrQ4WMeta?.path ?? "/admin/test-requests/page/:page()",
    meta: _91page_93Y7NVqzrQ4WMeta || {},
    alias: _91page_93Y7NVqzrQ4WMeta?.alias || [],
    redirect: _91page_93Y7NVqzrQ4WMeta?.redirect,
    component: () => import("/app/pages/admin/test-requests/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexYm9dzWmM2AMeta?.name ?? "admin-users",
    path: indexYm9dzWmM2AMeta?.path ?? "/admin/users",
    meta: indexYm9dzWmM2AMeta || {},
    alias: indexYm9dzWmM2AMeta?.alias || [],
    redirect: indexYm9dzWmM2AMeta?.redirect,
    component: () => import("/app/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93TxTzDWQjxgMeta?.name ?? "admin-users-page-page",
    path: _91page_93TxTzDWQjxgMeta?.path ?? "/admin/users/page/:page()",
    meta: _91page_93TxTzDWQjxgMeta || {},
    alias: _91page_93TxTzDWQjxgMeta?.alias || [],
    redirect: _91page_93TxTzDWQjxgMeta?.redirect,
    component: () => import("/app/pages/admin/users/page/[page].vue").then(m => m.default || m)
  },
  {
    name: confirmj8tMvini4qMeta?.name ?? "auth-confirm",
    path: confirmj8tMvini4qMeta?.path ?? "/auth/confirm",
    meta: confirmj8tMvini4qMeta || {},
    alias: confirmj8tMvini4qMeta?.alias || [],
    redirect: confirmj8tMvini4qMeta?.redirect,
    component: () => import("/app/pages/auth/confirm.vue").then(m => m.default || m)
  },
  {
    name: loginikXFF2hTKwMeta?.name ?? "auth-login",
    path: loginikXFF2hTKwMeta?.path ?? "/auth/login",
    meta: loginikXFF2hTKwMeta || {},
    alias: loginikXFF2hTKwMeta?.alias || [],
    redirect: loginikXFF2hTKwMeta?.redirect,
    component: () => import("/app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: registerTCvAsPw3TEMeta?.name ?? "auth-register",
    path: registerTCvAsPw3TEMeta?.path ?? "/auth/register",
    meta: registerTCvAsPw3TEMeta || {},
    alias: registerTCvAsPw3TEMeta?.alias || [],
    redirect: registerTCvAsPw3TEMeta?.redirect,
    component: () => import("/app/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: diet_45trackerHuONu4xFd9Meta?.name ?? "diet-tracker",
    path: diet_45trackerHuONu4xFd9Meta?.path ?? "/diet-tracker",
    meta: diet_45trackerHuONu4xFd9Meta || {},
    alias: diet_45trackerHuONu4xFd9Meta?.alias || [],
    redirect: diet_45trackerHuONu4xFd9Meta?.redirect,
    component: () => import("/app/pages/diet-tracker.vue").then(m => m.default || m)
  },
  {
    name: dietQjawD62golMeta?.name ?? "diet",
    path: dietQjawD62golMeta?.path ?? "/diet",
    meta: dietQjawD62golMeta || {},
    alias: dietQjawD62golMeta?.alias || [],
    redirect: dietQjawD62golMeta?.redirect,
    component: () => import("/app/pages/diet.vue").then(m => m.default || m)
  },
  {
    name: exercise_45doI3iSyudIGkMeta?.name ?? "exercise-do",
    path: exercise_45doI3iSyudIGkMeta?.path ?? "/exercise-do",
    meta: exercise_45doI3iSyudIGkMeta || {},
    alias: exercise_45doI3iSyudIGkMeta?.alias || [],
    redirect: exercise_45doI3iSyudIGkMeta?.redirect,
    component: () => import("/app/pages/exercise-do.vue").then(m => m.default || m)
  },
  {
    name: exercisem9SATYLrJIMeta?.name ?? "exercise",
    path: exercisem9SATYLrJIMeta?.path ?? "/exercise",
    meta: exercisem9SATYLrJIMeta || {},
    alias: exercisem9SATYLrJIMeta?.alias || [],
    redirect: exercisem9SATYLrJIMeta?.redirect,
    component: () => import("/app/pages/exercise.vue").then(m => m.default || m)
  },
  {
    name: _91expertId_93i22XIvoddvMeta?.name ?? "experts-expertId",
    path: _91expertId_93i22XIvoddvMeta?.path ?? "/experts/:expertId()",
    meta: _91expertId_93i22XIvoddvMeta || {},
    alias: _91expertId_93i22XIvoddvMeta?.alias || [],
    redirect: _91expertId_93i22XIvoddvMeta?.redirect,
    component: () => import("/app/pages/experts/[expertId].vue").then(m => m.default || m)
  },
  {
    name: edit_45profile9X3heypSReMeta?.name ?? "experts-edit-profile",
    path: edit_45profile9X3heypSReMeta?.path ?? "/experts/edit-profile",
    meta: edit_45profile9X3heypSReMeta || {},
    alias: edit_45profile9X3heypSReMeta?.alias || [],
    redirect: edit_45profile9X3heypSReMeta?.redirect,
    component: () => import("/app/pages/experts/edit-profile.vue").then(m => m.default || m)
  },
  {
    name: indexnpdT0JfAhGMeta?.name ?? "experts",
    path: indexnpdT0JfAhGMeta?.path ?? "/experts",
    meta: indexnpdT0JfAhGMeta || {},
    alias: indexnpdT0JfAhGMeta?.alias || [],
    redirect: indexnpdT0JfAhGMeta?.redirect,
    component: () => import("/app/pages/experts/index.vue").then(m => m.default || m)
  },
  {
    name: search3IVBizauxsMeta?.name ?? "experts-search",
    path: search3IVBizauxsMeta?.path ?? "/experts/search",
    meta: search3IVBizauxsMeta || {},
    alias: search3IVBizauxsMeta?.alias || [],
    redirect: search3IVBizauxsMeta?.redirect,
    component: () => import("/app/pages/experts/search.vue").then(m => m.default || m)
  },
  {
    name: homeH3NsyxtJwrMeta?.name ?? "home",
    path: homeH3NsyxtJwrMeta?.path ?? "/home",
    meta: homeH3NsyxtJwrMeta || {},
    alias: homeH3NsyxtJwrMeta?.alias || [],
    redirect: homeH3NsyxtJwrMeta?.redirect,
    component: () => import("/app/pages/home.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: insighttuGVwswgtYMeta?.name ?? "insight",
    path: insighttuGVwswgtYMeta?.path ?? "/insight",
    meta: insighttuGVwswgtYMeta || {},
    alias: insighttuGVwswgtYMeta?.alias || [],
    redirect: insighttuGVwswgtYMeta?.redirect,
    component: () => import("/app/pages/insight.vue").then(m => m.default || m)
  },
  {
    name: integration5OIuve0YMhMeta?.name ?? "integration",
    path: integration5OIuve0YMhMeta?.path ?? "/integration",
    meta: integration5OIuve0YMhMeta || {},
    alias: integration5OIuve0YMhMeta?.alias || [],
    redirect: integration5OIuve0YMhMeta?.redirect,
    component: () => import("/app/pages/integration.vue").then(m => m.default || m)
  },
  {
    name: add0M9PZgNwJNMeta?.name ?? "manage-blood-tests-add",
    path: add0M9PZgNwJNMeta?.path ?? "/manage-blood-tests/add",
    meta: add0M9PZgNwJNMeta || {},
    alias: add0M9PZgNwJNMeta?.alias || [],
    redirect: add0M9PZgNwJNMeta?.redirect,
    component: () => import("/app/pages/manage-blood-tests/add.vue").then(m => m.default || m)
  },
  {
    name: index9Elpj8EnZ6Meta?.name ?? "manage-blood-tests",
    path: index9Elpj8EnZ6Meta?.path ?? "/manage-blood-tests",
    meta: index9Elpj8EnZ6Meta || {},
    alias: index9Elpj8EnZ6Meta?.alias || [],
    redirect: index9Elpj8EnZ6Meta?.redirect,
    component: () => import("/app/pages/manage-blood-tests/index.vue").then(m => m.default || m)
  },
  {
    name: addx2O3s2izsWMeta?.name ?? "manage-events-add",
    path: addx2O3s2izsWMeta?.path ?? "/manage-events/add",
    meta: addx2O3s2izsWMeta || {},
    alias: addx2O3s2izsWMeta?.alias || [],
    redirect: addx2O3s2izsWMeta?.redirect,
    component: () => import("/app/pages/manage-events/add.vue").then(m => m.default || m)
  },
  {
    name: addhpe3NeWxLAMeta?.name ?? "manage-medicines-add",
    path: addhpe3NeWxLAMeta?.path ?? "/manage-medicines/add",
    meta: addhpe3NeWxLAMeta || {},
    alias: addhpe3NeWxLAMeta?.alias || [],
    redirect: addhpe3NeWxLAMeta?.redirect,
    component: () => import("/app/pages/manage-medicines/add.vue").then(m => m.default || m)
  },
  {
    name: indexk5tQnOwITiMeta?.name ?? "manage-medicines",
    path: indexk5tQnOwITiMeta?.path ?? "/manage-medicines",
    meta: indexk5tQnOwITiMeta || {},
    alias: indexk5tQnOwITiMeta?.alias || [],
    redirect: indexk5tQnOwITiMeta?.redirect,
    component: () => import("/app/pages/manage-medicines/index.vue").then(m => m.default || m)
  },
  {
    name: manage_45testsVt5Hq0CvpJMeta?.name ?? "manage-tests",
    path: manage_45testsVt5Hq0CvpJMeta?.path ?? "/manage-tests",
    meta: manage_45testsVt5Hq0CvpJMeta || {},
    alias: manage_45testsVt5Hq0CvpJMeta?.alias || [],
    redirect: manage_45testsVt5Hq0CvpJMeta?.redirect,
    component: () => import("/app/pages/manage-tests.vue").then(m => m.default || m)
  },
  {
    name: meditationELSFM90O91Meta?.name ?? "meditation",
    path: meditationELSFM90O91Meta?.path ?? "/meditation",
    meta: meditationELSFM90O91Meta || {},
    alias: meditationELSFM90O91Meta?.alias || [],
    redirect: meditationELSFM90O91Meta?.redirect,
    component: () => import("/app/pages/meditation.vue").then(m => m.default || m)
  },
  {
    name: notifications883AI3QFtaMeta?.name ?? "notifications",
    path: notifications883AI3QFtaMeta?.path ?? "/notifications",
    meta: notifications883AI3QFtaMeta || {},
    alias: notifications883AI3QFtaMeta?.alias || [],
    redirect: notifications883AI3QFtaMeta?.redirect,
    component: () => import("/app/pages/notifications.vue").then(m => m.default || m)
  },
  {
    name: onboardingY3u2kqL19PMeta?.name ?? "onboarding",
    path: onboardingY3u2kqL19PMeta?.path ?? "/onboarding",
    meta: onboardingY3u2kqL19PMeta || {},
    alias: onboardingY3u2kqL19PMeta?.alias || [],
    redirect: onboardingY3u2kqL19PMeta?.redirect,
    component: () => import("/app/pages/onboarding.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QJRK5g1YZ6Meta?.name ?? "page-slug",
    path: _91_46_46_46slug_93QJRK5g1YZ6Meta?.path ?? "/page/:slug(.*)*",
    meta: _91_46_46_46slug_93QJRK5g1YZ6Meta || {},
    alias: _91_46_46_46slug_93QJRK5g1YZ6Meta?.alias || [],
    redirect: _91_46_46_46slug_93QJRK5g1YZ6Meta?.redirect,
    component: () => import("/app/pages/page/[...slug].vue").then(m => m.default || m)
  },
  {
    name: pose_45testnxVflwwJb7Meta?.name ?? "pose-test",
    path: pose_45testnxVflwwJb7Meta?.path ?? "/pose-test",
    meta: pose_45testnxVflwwJb7Meta || {},
    alias: pose_45testnxVflwwJb7Meta?.alias || [],
    redirect: pose_45testnxVflwwJb7Meta?.redirect,
    component: () => import("/app/pages/pose-test.vue").then(m => m.default || m)
  },
  {
    name: profileupBlgdy3vLMeta?.name ?? "profile",
    path: profileupBlgdy3vLMeta?.path ?? "/profile",
    meta: profileupBlgdy3vLMeta || {},
    alias: profileupBlgdy3vLMeta?.alias || [],
    redirect: profileupBlgdy3vLMeta?.redirect,
    component: () => import("/app/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: request_45new_45testKhQrJPfFTtMeta?.name ?? "request-new-test",
    path: request_45new_45testKhQrJPfFTtMeta?.path ?? "/request-new-test",
    meta: request_45new_45testKhQrJPfFTtMeta || {},
    alias: request_45new_45testKhQrJPfFTtMeta?.alias || [],
    redirect: request_45new_45testKhQrJPfFTtMeta?.redirect,
    component: () => import("/app/pages/request-new-test.vue").then(m => m.default || m)
  },
  {
    name: cartRH4WHc4AXrMeta?.name ?? "shop-cart",
    path: cartRH4WHc4AXrMeta?.path ?? "/shop/cart",
    meta: cartRH4WHc4AXrMeta || {},
    alias: cartRH4WHc4AXrMeta?.alias || [],
    redirect: cartRH4WHc4AXrMeta?.redirect,
    component: () => import("/app/pages/shop/cart.vue").then(m => m.default || m)
  },
  {
    name: indexNvxd1fRHrwMeta?.name ?? "shop",
    path: indexNvxd1fRHrwMeta?.path ?? "/shop",
    meta: indexNvxd1fRHrwMeta || {},
    alias: indexNvxd1fRHrwMeta?.alias || [],
    redirect: indexNvxd1fRHrwMeta?.redirect,
    component: () => import("/app/pages/shop/index.vue").then(m => m.default || m)
  },
  {
    name: order_45confirmationlHkZIHLQx1Meta?.name ?? "shop-order-confirmation",
    path: order_45confirmationlHkZIHLQx1Meta?.path ?? "/shop/order-confirmation",
    meta: order_45confirmationlHkZIHLQx1Meta || {},
    alias: order_45confirmationlHkZIHLQx1Meta?.alias || [],
    redirect: order_45confirmationlHkZIHLQx1Meta?.redirect,
    component: () => import("/app/pages/shop/order-confirmation.vue").then(m => m.default || m)
  },
  {
    name: order_45doneBCftytavRwMeta?.name ?? "shop-order-done",
    path: order_45doneBCftytavRwMeta?.path ?? "/shop/order-done",
    meta: order_45doneBCftytavRwMeta || {},
    alias: order_45doneBCftytavRwMeta?.alias || [],
    redirect: order_45doneBCftytavRwMeta?.redirect,
    component: () => import("/app/pages/shop/order-done.vue").then(m => m.default || m)
  },
  {
    name: ordersLQL6ekTo64Meta?.name ?? "shop-orders",
    path: ordersLQL6ekTo64Meta?.path ?? "/shop/orders",
    meta: ordersLQL6ekTo64Meta || {},
    alias: ordersLQL6ekTo64Meta?.alias || [],
    redirect: ordersLQL6ekTo64Meta?.redirect,
    component: () => import("/app/pages/shop/orders.vue").then(m => m.default || m)
  },
  {
    name: paymenttOXdFmr7DPMeta?.name ?? "shop-payment",
    path: paymenttOXdFmr7DPMeta?.path ?? "/shop/payment",
    meta: paymenttOXdFmr7DPMeta || {},
    alias: paymenttOXdFmr7DPMeta?.alias || [],
    redirect: paymenttOXdFmr7DPMeta?.redirect,
    component: () => import("/app/pages/shop/payment.vue").then(m => m.default || m)
  },
  {
    name: _91productId_93sZ6lovkuHdMeta?.name ?? "shop-product-productId",
    path: _91productId_93sZ6lovkuHdMeta?.path ?? "/shop/product/:productId()",
    meta: _91productId_93sZ6lovkuHdMeta || {},
    alias: _91productId_93sZ6lovkuHdMeta?.alias || [],
    redirect: _91productId_93sZ6lovkuHdMeta?.redirect,
    component: () => import("/app/pages/shop/product/[productId].vue").then(m => m.default || m)
  },
  {
    name: indexUVI39vtgp1Meta?.name ?? "test",
    path: indexUVI39vtgp1Meta?.path ?? "/test",
    meta: indexUVI39vtgp1Meta || {},
    alias: indexUVI39vtgp1Meta?.alias || [],
    redirect: indexUVI39vtgp1Meta?.redirect,
    component: () => import("/app/pages/test/index.vue").then(m => m.default || m)
  },
  {
    name: vivaiHwv6rVa4baMeta?.name ?? "vivai",
    path: vivaiHwv6rVa4baMeta?.path ?? "/vivai",
    meta: vivaiHwv6rVa4baMeta || {},
    alias: vivaiHwv6rVa4baMeta?.alias || [],
    redirect: vivaiHwv6rVa4baMeta?.redirect,
    component: () => import("/app/pages/vivai.vue").then(m => m.default || m)
  },
  {
    name: workoutTVjCE2fZquMeta?.name ?? "workout",
    path: workoutTVjCE2fZquMeta?.path ?? "/workout",
    meta: workoutTVjCE2fZquMeta || {},
    alias: workoutTVjCE2fZquMeta?.alias || [],
    redirect: workoutTVjCE2fZquMeta?.redirect,
    component: () => import("/app/pages/workout.vue").then(m => m.default || m)
  }
]